"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenu = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const MenuList_1 = __importDefault(require("@material-ui/core/MenuList"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const menu_styles_1 = require("./menu-styles");
const sub_menu_item_1 = require("./sub-menu-item");
function SubMenu({ items, opened, topLevel, classOverrides, }) {
    const classes = menu_styles_1.useStyles();
    const [openedItem, setOpenedItem] = react_1.useState(null);
    const handleItemHover = event_callback_hook_1.useEventCallback((index) => {
        setOpenedItem(index);
    });
    let topLevelClassName = `${classes.subMenuTopLevel}`;
    if (classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.subMenuTopLevel) {
        topLevelClassName += ` ${classOverrides.subMenuTopLevel}`;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, opened && (react_1.default.createElement(MenuList_1.default, { classes: {
            root: clsx_1.default(classes.subMenu, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.subMenu, {
                [topLevelClassName]: topLevel,
            }),
        }, disablePadding: true }, items.map((item, index) => item.separator ? (react_1.default.createElement(Divider_1.default, { key: index, variant: "middle" })) : (react_1.default.createElement(sub_menu_item_1.SubMenuItem, { SubMenuComponent: SubMenu, item: item, key: index, index: index, onHover: handleItemHover, opened: index === openedItem, classOverrides: classOverrides })))))));
}
exports.SubMenu = SubMenu;
//# sourceMappingURL=sub-menu.js.map